import { createContext, useState, useCallback } from 'react'

interface PageInfo {
  title: string
  subtitle?: string
  backPath?: string
}

interface PageContextType {
  pageInfo: PageInfo | null
  setPageInfo: (info: PageInfo | null) => void
}

// eslint-disable-next-line react-refresh/only-export-components
export const PageContext = createContext<PageContextType | undefined>(undefined)

interface PageProviderProps {
  children: React.ReactNode
}

export function PageProvider({ children }: PageProviderProps) {
  const [pageInfo, setPageInfoState] = useState<PageInfo | null>(null)

  const setPageInfo = useCallback((info: PageInfo | null) => {
    setPageInfoState(info)
  }, [])

  return <PageContext.Provider value={{ pageInfo, setPageInfo }}>{children}</PageContext.Provider>
}
